import type { StrengthConfig } from "./types";
import { getStrengthConfigByLevel } from "./helper";

interface StrengthLabelProps {
    password: string;
    strengthLevel: number;
    strengthConfig: StrengthConfig;
}

const StrengthLabel = ({
    password,
    strengthLevel,
    strengthConfig,
}: StrengthLabelProps) => {
    const { label, textColor } = getStrengthConfigByLevel(
        password,
        strengthLevel,
        strengthConfig
    );

    return (
        <div className='text-right mt-2'>
            <span className={`text-sm font-medium ${textColor}`}>{label}</span>
        </div>
    );
};

export default StrengthLabel;
